import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Checks uppercase and number requirements independently (instead of one
 * combined regex) so the error message can name only what's actually
 * missing — e.g. "test@123" is missing an uppercase letter but already has
 * a number, so only the uppercase requirement should be reported.
 */
export function passwordComplexityValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value ?? '';
  if (!value) return null;

  const errors: ValidationErrors = {};
  if (!/[A-Z]/.test(value)) errors['needsUppercase'] = true;
  if (!/[0-9]/.test(value)) errors['needsNumber'] = true;
  if (/\s/.test(value)) errors['hasSpace'] = true;

  return Object.keys(errors).length ? errors : null;
}

export function passwordComplexityMessage(errors: ValidationErrors): string {
  if (errors['hasSpace']) return 'Password cannot contain spaces';

  const missing: string[] = [];
  if (errors['needsUppercase']) missing.push('1 uppercase letter');
  if (errors['needsNumber']) missing.push('1 number');
  return `Must contain at least ${missing.join(' and ')}`;
}
